if (!customElements.get('custom-image-width-text')) {
  customElements.define(
    'custom-image-width-text',
    class CustomImageWidthText extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.custom-image-width-text__track');
        this.slides = [...this.querySelectorAll('.custom-image-width-text__slide')];
        this.buttons = [...this.querySelectorAll('.custom-image-width-text__pagination-button')];
        this.desktopQuery = window.matchMedia('(min-width: 700px)');
        this.currentPage = 0;

        if (!this.track || this.slides.length < 2) return;

        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };

        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.goToPage(index), options);
        });

        this.addEventListener('keydown', this.handleKeydown.bind(this), options);
        this.desktopQuery.addEventListener('change', () => this.update(), options);
        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      handleKeydown(event) {
        if (!this.desktopQuery.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextPage = (this.currentPage + direction + this.slides.length) % this.slides.length;
        this.goToPage(nextPage);
        this.buttons[nextPage]?.focus();
      }

      goToPage(index) {
        this.currentPage = Math.max(0, Math.min(index, this.slides.length - 1));
        this.update();
      }

      update() {
        const isDesktop = this.desktopQuery.matches;
        this.track.style.transform = isDesktop ? `translateX(${-100 * this.currentPage}%)` : '';

        this.slides.forEach((slide, index) => {
          if (isDesktop) {
            slide.setAttribute('aria-hidden', index === this.currentPage ? 'false' : 'true');
            if ('inert' in slide) slide.inert = index !== this.currentPage;
          } else {
            slide.removeAttribute('aria-hidden');
            if ('inert' in slide) slide.inert = false;
          }
        });

        this.buttons.forEach((button, index) => {
          button.setAttribute('aria-current', index === this.currentPage ? 'true' : 'false');
        });
      }
    }
  );
}
